<script lang="ts">
	import { BoxShadow } from '@repo/ui'
	import { BoxHeadline } from '@repo/ui'
	import type { Snippet } from 'svelte'

	interface Props {
		medium?: boolean
		compact?: boolean
		small?: boolean
		id?: string | null
		title?: string | null
		description?: string | null
		transparent?: boolean
		joinTop?: boolean
		class?: string
		children?: Snippet
		toolbar?: Snippet
	}

	let {
		medium = false,
		compact = false,
		small = false,
		id = null,
		title = null,
		description = null,
		transparent = false,
		joinTop = false,
		class: className = '',
		children,
		toolbar = null,
	}: Props = $props()
</script>

<BoxShadow {joinTop} {transparent}>
	<div
		class="relative flex flex-col p-4 text-sm {compact
			? 'lg:px-9 lg:py-7'
			: small
				? 'px-3 py-3'
				: medium
					? 'px-5 py-4'
					: 'lg:p-9'} lg:text-base {className}"
		data-test={id}
	>
		{#if title}
			<div class="mb-7 flex items-center justify-between gap-4">
				<BoxHeadline {title}></BoxHeadline>

				{@render toolbar?.()}
			</div>
		{/if}

		{#if description}
			<p class="mb-4">
				{description}
			</p>
		{/if}
		{@render children?.()}
	</div>
</BoxShadow>
